"use strict";
/**
 * Dashboard shapes.
 *
 * All of these are answered from the same event log. The distinction that
 * matters is not which dashboard asks but how wide its scope is: a school admin
 * reads their own org, a ministry analyst reads a subtree. That is one ltree
 * predicate, `org_path <@ :scope`, and one permission, `analytics@read_subtree`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=analytics.js.map